import Vue from 'vue';
export default Vue.extend({
    name: 'bonusRulesPopupChunk',
    props: {
        slotData: {
            required: false
        }
    }
});
